var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 0C4.48576 0 0 4.4859 0 9.99982C0 15.5139 4.48576 20 9.9999 20C15.5137 20 19.9998 15.5139 19.9998 9.99982C19.9998 4.4859 15.5137 0 9.9999 0ZM12.8262 6.31269C12.8262 6.36004 12.8073 6.40545 12.7739 6.43893C12.7404 6.47242 12.695 6.49123 12.6476 6.49123L11.5109 6.49194C10.7608 6.49194 10.6237 6.78402 10.6237 7.35927V8.55261H12.5733C12.6246 8.55261 12.6735 8.57474 12.7072 8.61331C12.741 8.65187 12.7567 8.70311 12.7505 8.75399L12.4728 10.9023C12.4673 10.9454 12.4462 10.9849 12.4136 11.0136C12.381 11.0422 12.3391 11.058 12.2957 11.058H10.6237V16.3925C10.6237 16.4398 10.6049 16.4853 10.5714 16.5187C10.5379 16.5522 10.4925 16.571 10.4452 16.571H8.22702C8.17967 16.571 8.13426 16.5522 8.10077 16.5187C8.06729 16.4853 8.04848 16.4398 8.04848 16.3925V11.058H6.37112C6.32377 11.058 6.27836 11.0392 6.24487 11.0057C6.21139 10.9722 6.19258 10.9268 6.19258 10.8795V8.73114C6.19258 8.68379 6.21139 8.63838 6.24487 8.6049C6.27836 8.57142 6.32377 8.55261 6.37112 8.55261H8.04848V7.14663C8.04848 5.2845 9.17541 4.12794 10.9899 4.12794C11.7699 4.12794 12.4593 4.18596 12.671 4.21399C12.7139 4.21966 12.7533 4.24073 12.7819 4.27328C12.8104 4.30583 12.8261 4.34764 12.8262 4.39092V6.31269Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.84b5de73575acf4458bb719174ca78d8.svg";
export { ForwardRef as ReactComponent };